var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import authentication from "@irati/auth";
import API from "@irati/utils/services/API";
import client from "@irati/utils/services/apollo";
import graph from "@irati/utils/services/graph";
import parseTenant from "@irati/identity/helpers/parseTenant";
import { getGraphError as checkForGraphError } from "@irati/utils/services/API/utils/errorHandler";
import loginErrorCodes from "../errorCodes/Login";
import featureFlagsService from "./featureFlags";
import loginErrorHandler from "./errors/loginErrorHandler";
import { toString as loginQuery } from "./queries/login";
import { toString as ssoLoginQuery } from "./queries/ssoLogin";
import resumeQuery from "./queries/resume";
import activeSessionsQuery from "./queries/loginActiveSessions";
import loginRemoveActiveSessionMutation from "./mutations/loginRemoveActiveSession";
import loginLogoutMutation from "./mutations/loginLogout";
var Login = /** @class */ (function () {
    function Login() {
    }
    Login.prototype.getActive = function (userId) {
        if (userId === void 0) { userId = authentication.user().uuid; }
        var variables = { userId: userId };
        return client.query({ query: activeSessionsQuery, variables: variables, fetchPolicy: "network-only" }).then(function (_a) {
            var data = _a.data;
            return data.loginActiveSessions;
        });
    };
    Login.prototype.removeActiveSession = function (sessionId, userId) {
        if (userId === void 0) { userId = authentication.user().uuid; }
        var variables = { userId: userId, sessionId: sessionId };
        return client.mutate({ mutation: loginRemoveActiveSessionMutation, variables: variables }).then(function (_a) {
            var data = _a.data;
            return data.loginRemoveActiveSession;
        });
    };
    Login.prototype.logout = function () {
        return client.mutate({ mutation: loginLogoutMutation }).then(function () { return true; });
    };
    Login.prototype.login = function (tenant, email, password) {
        var options = {
            useErrorHandler: false,
            unAuth: true
        };
        API.sentryIgnoreError(options, [loginErrorCodes.LoginChallengeNewPasswordRequired, loginErrorCodes.UserNotFound]);
        var variables = {
            email: email,
            password: password,
            tenantId: tenant.uuid
        };
        return graph({ query: loginQuery, variables: variables }, options)
            .then(function (data) { return parseResponse(data); })
            .catch(loginErrorHandler);
    };
    Login.prototype.ssoLogin = function (tenant, user, accessToken) {
        var options = {
            useErrorHandler: false
        };
        var variables = {
            userId: user.uuid,
            accessToken: accessToken,
            tenantId: tenant.uuid
        };
        return graph({ query: ssoLoginQuery, variables: variables }, options)
            .then(function (data) { return parseResponse(data); })
            .catch(loginErrorHandler);
    };
    Login.prototype.resume = function (tenant, user) {
        return client
            .query({
            query: resumeQuery,
            variables: {
                userId: user.uuid,
                tenantId: tenant.uuid
            }
        })
            .then(function (_a) {
            var data = _a.data;
            return parseResumeResponse(data);
        });
    };
    return Login;
}());
export default new Login();
function parseResponse(data) {
    checkForGraphError(data);
    // Set default values
    data.login.userTenant = parseTenant(data.login.userTenant, {});
    return featureFlagsService.get(data.login.userTenant).then(function (featureFlags) {
        return __assign(__assign({ featureFlags: featureFlags }, data.login), { onboarding: data.login.userOnboarding, upsell: { region: data.login.upsellRegion } });
    });
}
function parseResumeResponse(data) {
    var resumeSession = data.resumeSession, upsellRegion = data.upsellRegion;
    resumeSession.userTenant = parseTenant(resumeSession.userTenant, {});
    return featureFlagsService.get(resumeSession.userTenant).then(function (featureFlags) {
        return __assign(__assign({ featureFlags: featureFlags }, resumeSession), { onboarding: resumeSession.userOnboarding, upsell: { region: upsellRegion } });
    });
}
